import React from 'react';
import { Box, VStack } from '@chakra-ui/react';
import HeroSection from './components/HeroSection';
import ValuesSection from './components/ValuesSection';
import ProcessCards from './components/ProcessCards';
import TargetSection from './components/TargetSection';
import PioneerSection from './components/PioneerSection';
import LevelsSection from './components/LevelsSection';

export default function HomePage() {
  return (
    <Box 
      bg="#f9f9f9"
      minH="100vh"
    >
      {/* 
        Main content container
        Figma spec: Frame 23 at x=25, max-inner-width=1230px, gap=20px between sections
        px matches the Figma outer padding (25px mobile, 30px desktop)
      */}
      <VStack 
        maxW="1230px" 
        mx="auto"
        px={{ base: "20px", md: "25px" }}
        spacing="20px"
        align="stretch"
        pb="20px"
      >
        <HeroSection />
        <ValuesSection />
        <ProcessCards />
        <TargetSection />
        <PioneerSection />
        <LevelsSection />
      </VStack>
    </Box>
  );
}
